import React from 'react';
import TextField from '@material-ui/core/TextField';
import { PropTypes } from 'prop-types';

/**
 * Renderiza un componente de campo de texto.
 *
 * @param {Object} props - El objeto de propiedades.
 * @param {string} props.id - El ID del campo de texto.
 * @param {string} props.name - El nombre del campo de texto.
 * @param {string} props.type - El tipo del campo de texto.
 * @param {boolean} props.fullWidth - Si el campo de texto debe ocupar todo el ancho.
 * @param {boolean} props.multiline - Si el campo de texto debe tener varias líneas.
 * @param {boolean} props.error - Si el campo de texto tiene un error.
 * @param {boolean} props.disabled - Si el campo de texto está deshabilitado.
 * @param {string} props.label - La etiqueta del campo de texto.
 * @param {string} props.helperText - El texto de ayuda del campo de texto.
 * @param {string} props.variant - La variante del campo de texto.
 * @param {function} props.onChange - El controlador de eventos onChange para el campo de texto.
 * @param {string} props.value - El valor del campo de texto.
 * @param {string} props.color - El color del campo de texto.
 * @param {Object} props.style - El objeto de estilo para el campo de texto.
 * @return {JSX.Element} - El componente de campo de texto renderizado.
 */

TextFieldCS.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  maxRows: PropTypes.number,
  type: PropTypes.string,
  shrink: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.string,
};

TextFieldCS.defaultProps = {
  id: 'Custom',
  name: 'Custom',
  error: false,
  helperText: "",
  variant: "standard",
  label: "",
  disabled: false,
  fullWidth: true,
  multiline: false,
  type: "text",
  shrink: true,
  value: '',
  color: 'primary',
  onChange: () => { }
}

function TextFieldCS(props) {

  return (<>
    <div>
      <TextField
        id={props.id}
        name={props.name}
        type={props.type}
        fullWidth={props.fullWidth}
        multiline={props.multiline}
        error={props.error}
        disabled={props.disabled}
        label={props.label}
        helperText={props.helperText}
        variant={props.variant}
        onChange={props.onChange}
        value={props.value}
        color={props.color}
        style={props.style}
      >
      </TextField>
    </div>
  </>)
}

export default React.memo(TextFieldCS);
